import {distributionWebsocketCommands} from '../../constants/distributionWebsocketCommands';
import {commercialWebsocketCommands} from '../../constants/commercialWebsocketCommands';
import {marketingWebsocketCommands} from '../../constants/marketingWebsocketCommands';
import {domains} from '../../constants/Utils';

export const ADMIN_PRESET_RESPONSE_SELECT_GROUP = 'ADMIN_PRESET_RESPONSE_SELECT_GROUP';
export const ADMIN_PRESET_RESPONSE_FETCH = 'ADMIN_PRESET_RESPONSE_FETCH';
export const ADMIN_PRESET_RESPONSE_ADD = 'ADMIN_PRESET_RESPONSE_ADD';
export const ADMIN_PRESET_RESPONSE_EDIT = 'ADMIN_PRESET_RESPONSE_EDIT';
export const ADMIN_PRESET_RESPONSE_UPDATE = 'ADMIN_PRESET_RESPONSE_UPDATE';
export const ADMIN_PRESET_RESPONSE_MOVE = 'ADMIN_PRESET_RESPONSE_MOVE';
export const ADMIN_PRESET_RESPONSE_SWITCH = 'ADMIN_PRESET_RESPONSE_SWITCH';
export const ADMIN_PRESET_RESPONSE_REMOVE = 'ADMIN_PRESET_RESPONSE_REMOVE';

export const storeSelectedCountryGroup = countryGroup => dispatch =>
    dispatch({
        type: ADMIN_PRESET_RESPONSE_SELECT_GROUP,
        payload: countryGroup
    });

export const fetchPresetResponse = (domain, group) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_FETCH,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_PRESET_RESPONSE_GET,
                payload: {group}
            });
        }
        case domains.COMMERCIAL: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_FETCH,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_PRESET_RESPONSE_GET,
                payload: {group}
            });
        }
        case domains.MARKETING: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_FETCH,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_PRESET_RESPONSE_GET,
                payload: {group}
            });
        }
    }
};

export const addPresetResponse = (domain, presetResponse) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_ADD,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_PRESET_RESPONSE_CREATE,
                payload: {presetResponse}
            });
        }
        case domains.COMMERCIAL: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_ADD,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_PRESET_RESPONSE_CREATE,
                payload: {presetResponse}
            });
        }
        case domains.MARKETING: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_ADD,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_PRESET_RESPONSE_CREATE,
                payload: {presetResponse}
            });
        }
    }
};

export const editPresetResponse = index => dispatch => {
    dispatch({
        type: ADMIN_PRESET_RESPONSE_EDIT,
        payload: {index}
    });
};

export const updatePresetResponse = (domain, presetResponse) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_UPDATE,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_PRESET_RESPONSE_UPDATE,
                payload: {presetResponse}
            });
        }
        case domains.COMMERCIAL: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_UPDATE,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_PRESET_RESPONSE_UPDATE,
                payload: {presetResponse}
            });
        }
        case domains.MARKETING: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_UPDATE,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_PRESET_RESPONSE_UPDATE,
                payload: {presetResponse}
            });
        }
    }
};

export const movePresetResponse = (domain, presetResponse, oldIndex) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            dispatch({
                type: ADMIN_PRESET_RESPONSE_SWITCH,
                payload: {oldIndex, newIndex: presetResponse.position, presetResponse}
            });
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_MOVE,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_PRESET_RESPONSE_MOVE,
                payload: {presetResponse}
            });
        }
        case domains.COMMERCIAL: {
            dispatch({
                type: ADMIN_PRESET_RESPONSE_SWITCH,
                payload: {oldIndex, newIndex: presetResponse.position, presetResponse}
            });
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_MOVE,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_PRESET_RESPONSE_MOVE,
                payload: {presetResponse}
            });
        }
        case domains.MARKETING: {
            dispatch({
                type: ADMIN_PRESET_RESPONSE_SWITCH,
                payload: {oldIndex, newIndex: presetResponse.position, presetResponse}
            });
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_MOVE,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_PRESET_RESPONSE_MOVE,
                payload: {presetResponse}
            });
        }
    }
};

export const removePresetResponse = (domain, presetResponse) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_REMOVE,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_PRESET_RESPONSE_DELETE,
                payload: {presetResponse}
            });
        }
        case domains.COMMERCIAL: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_REMOVE,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_PRESET_RESPONSE_DELETE,
                payload: {presetResponse}
            });
        }
        case domains.MARKETING: {
            return dispatch({
                type: ADMIN_PRESET_RESPONSE_REMOVE,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_PRESET_RESPONSE_DELETE,
                payload: {presetResponse}
            });
        }
    }
};


